<!-- <div class="flex flex-row items-center">
  <div class="flex flex-row items-center justify-center">
    <mat-icon *ngIf="data.messages" class="icon-size-14" svgIcon="confirm_{{ data.type }}"></mat-icon>
    <mat-icon *ngIf="!data.messages" class="icon-size-12" svgIcon="confirm_{{ data.type }}"></mat-icon>
  </div>
  <div class="flex flex-col">
    <span class="font-bold text-h5 text-theme-dark">{{ data.title }}</span>
    <span class="whitespace-pre-line text-b1 text-theme-gray">{{ data.messages }}</span>
  </div>
</div> -->

<div class="flex items-center gap-3">
  <!-- <mat-icon class="text-white icon-size-6">done</mat-icon> -->
  <div class="flex-grow min-w-0">
    <div class="font-bold whitespace-pre-line text-s2-16 break-words">{{ data.title }}</div>
    <div class="whitespace-pre-line text-b2-14 break-words">{{ data.messages }}</div>
  </div>
  <mat-icon (click)="snackBarRef.dismiss()" class="text-white cursor-pointer icon-size-6">close</mat-icon>
</div>
